import React from "react";

export interface ViewerIframeProps {
  url: string;
  caseId: string;
  encryptedAuth: string;
  loadAllSeries: boolean;
  seriesId?: string;
  hasDownloadZip?: boolean;
  /** Pass-through from webapp URL so viewer "Cases" can return to the same list + filters */
  viewerListPath?: string;
  viewerListSearch?: string;
  /** When set (e.g. split layout with report drawer), applied to the iframe element */
  frameStyle?: React.CSSProperties;
}

const ViewerIframe = React.forwardRef<HTMLIFrameElement, ViewerIframeProps>(
  function ViewerIframe(
    {
      url,
      caseId,
      encryptedAuth,
      loadAllSeries,
      seriesId,
      hasDownloadZip = false,
      viewerListPath,
      viewerListSearch,
      frameStyle,
    },
    ref
  ) {
    const seriesParam = seriesId
      ? `&seriesId=${encodeURIComponent(seriesId)}`
      : "";
    const listReturnParam =
      viewerListPath != null && viewerListPath !== ""
        ? `&viewerListPath=${encodeURIComponent(viewerListPath)}${
            viewerListSearch
              ? `&viewerListSearch=${encodeURIComponent(viewerListSearch)}`
              : ""
          }`
        : "";
    return (
      <iframe
        ref={ref}
        src={`${url}?caseId=${caseId}&auth=${encryptedAuth}&guest=false&loadAllSeries=${loadAllSeries}${seriesParam}&hasDownloadZip=${hasDownloadZip}&embedded=1${listReturnParam}`}
        title="Case viewer"
        className="viewer-wrapper__iframe"
        style={frameStyle}
        allow="clipboard-write; clipboard-read"
      />
    );
  }
);

export default ViewerIframe;
